import {
  ConfiguredPasses,
  TournamentPass,
  UserPasses,
} from '@fantaz/shared/data-access/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PASSES_FEATURE_KEY, State, passesAdapter } from './passes.reducer';

// Lookup the 'Passes' feature state managed by NgRx
export const getPassesState = createFeatureSelector<State>(PASSES_FEATURE_KEY);

const { selectAll, selectEntities } = passesAdapter.getSelectors();

export const getPassesLoaded = createSelector(
  getPassesState,
  (state: State) => state.loaded,
);

export const getPassesError = createSelector(
  getPassesState,
  (state: State) => state.error,
);

export const getTournamentPasses = createSelector(
  getPassesState,
  (state: State) => state.entities,
);

export const getAllPasses = createSelector(getPassesState, (state: State) =>
  selectAll(state),
);

export const getPassesEntities = createSelector(
  getPassesState,
  (state: State) => selectEntities(state),
);

export const getActivePass = createSelector(
  getAllPasses,
  (passes: TournamentPass[]): TournamentPass | undefined | null => {
    if (passes.length > 0) {
      return passes.find((p) => p.activeCount && p.userUuid) || null;
    }

    return null;
  },
);
export const getPassesUsage = createSelector(
  getAllPasses,
  (passes: TournamentPass[]) => {
    if (passes.length > 0) {
      const res = passes.find((p) => getPassUsage(p));
      return res;
    }
    return null;
  },
);

function getPassUsage(pass: ConfiguredPasses | UserPasses): boolean {
  let canBeUsed = true;
  if (
    pass.price.promoCodes &&
    pass.price.promoCodes.length &&
    !isActivePass(pass)
  ) {
    canBeUsed = !!pass.price.promoCodes[0]?.canBeUsed;
  }
  return canBeUsed;
}

function isActivePass(pass: ConfiguredPasses | UserPasses) {
  return 'activeCount' in pass;
}

export const getActiveCount = createSelector(
  getActivePass,
  (pass: TournamentPass | undefined | null): number | undefined | null => {
    if (pass) {
      return pass.activeCount as number;
    }

    return null;
  },
);

export const selectQueryParams = createSelector(
  getPassesState,
  (state) => state.query,
);

export const selectIsBuyingTournamentPass = createSelector(
  getPassesState,
  (state) => state.buyingTournamentPass,
);
